module.exports = __webpack_public_path__ + "img/menu_gomb_kutatasok_aktiv.c9094aaa.png";